import { render, staticRenderFns } from "./updateServiceDialog.vue?vue&type=template&id=01a36dcf&scoped=true"
import script from "./updateServiceDialog.vue?vue&type=script&lang=js"
export * from "./updateServiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a36dcf",
  null
  
)

export default component.exports